'use client';

import PortfolioEarnStatsCard from 'src/components/PortfolioPage/PortfolioEarnSubPage/PortfolioEarnStatsCard';
import PortfolioEarnBalancesTable from 'src/components/PortfolioPage/PortfolioEarnSubPage/PortfolioEarnBalancesTable';
import PortfolioEarnReferralCard from 'src/components/PortfolioPage/PortfolioEarnSubPage/PortfolioEarnReferralCard';

export default function PortfolioEarnSubPage() {
	return (
		<div className="flex flex-col gap-y-lg sm:gap-y-8">
			<PortfolioEarnStatsCard />
			<PortfolioEarnBalancesTable />
			<PortfolioEarnReferralCard />
		</div>
	);
}
